import React, { useState } from 'react';
import {
  Drawer, DrawerHeader, DrawerBody, Button
} from '@one-thd/sui-atomic-components';
import { RichText } from '@thd-olt-component-react/rich-text';
import PropTypes from 'prop-types';

export const HotspotDrawer = ({ style, drawerData }) => {

  const { headline: DrawerHeaderText, drawerContent } = drawerData;

  const [legalDrawerOpen, setLegalDrawerOpen] = useState(false);


  const DrawerBodyContent = drawerContent?.map((contentItem, index) => {
    if (contentItem?.__typename === 'Description_New') {
      return (<RichText key={index} content={contentItem?.description} />);
    }
    
    if (contentItem?.__typename === 'DrawerImage' && contentItem?.image !== null) {
      const imageUrl = contentItem?.image?.damDownloadedContent?.url
        || contentItem?.image?.damContentSelector?.assetData?.[0]?.selectedImageUrl;
      const altText = contentItem?.image?.title || 'Hotspot drawer image';

      return (<img key={index} src={imageUrl} alt={altText} className="sui-w-full" />);
    }
  });

  if (!DrawerHeaderText || !DrawerBodyContent) {
    return null;
  }

  return (
    <div data-testid="hotspot-drawer">
      <Drawer open={legalDrawerOpen} onClose={() => setLegalDrawerOpen(false)}>
        <DrawerHeader
          height="tight"
          title={DrawerHeaderText}
          onClose={() => setLegalDrawerOpen(false)}
        />
        <DrawerBody>{DrawerBodyContent}</DrawerBody>
      </Drawer>

      <div
        className="sui-absolute"
        data-testid="hotspot-drawer-block"
        style={style}
      >
        <button
          type="button"
          onClick={() => setLegalDrawerOpen(true)}
          aria-label={`Open drawer for ${DrawerHeaderText}`}
          className="sui-block sui-cursor-pointer sui-h-full sui-w-full"
        />
      </div>
    </div>
  );
};

HotspotDrawer.propTypes = {
  style: PropTypes.shape({
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
    left: PropTypes.string.isRequired,
    top: PropTypes.string.isRequired,
  }).isRequired,
  drawerData: PropTypes.shape({
    headline: PropTypes.string,
    drawerContent: PropTypes.arrayOf(PropTypes.shape({})),
  })
};

HotspotDrawer.defaultProps = {
  drawerData: {
    headline: null,
    drawerContent: []
  },
};

export default HotspotDrawer;